import './category.scss';import Sloth from '../Sloth';


/** WEBPACK FOOTER **
 ** ./components/Category/category.js
 **/